import { IconButton, Typography } from '@mui/material';
import { LightTooltip } from 'lib/designSystem/WhiteTooltip';
import React from 'react';

interface InfoRowActionProps {
  icon: React.ReactNode;
  onClick?: () => void;
  tooltipText: string;
}

const InfoRowAction: React.FC<InfoRowActionProps> = ({
  icon,
  onClick,
  tooltipText,
}) => {
  return (
    <LightTooltip
      title={<Typography padding={1}>{tooltipText}</Typography>}
      disableHoverListener={!onClick}
    >
      <IconButton
        onClick={onClick}
        size="small"
        disabled={!onClick}
        sx={{
          color: 'text.secondary',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        }}
      >
        {icon}
      </IconButton>
    </LightTooltip>
  );
};

export default InfoRowAction;
